import { deleteNotificationContact } from './deleteNotificationContactThunk';
export default deleteNotificationContact;
